import React, { Component } from "react";
import PropTypes from "prop-types";

import Picks from "./Picks";
import { TeamShape } from "./nfl";
import QuarterSummary from "./QuarterSummary";
import SquaresTable from "./SquaresTable";
import { FONT_LEAGUE, FONT_THIN } from "./styles";

const SIDE_WIDTH = 88;
const GRAY_TEXT = {
  color: "#aaa",
};

const STYLE_CITY = {
  fontSize: 64,
  fontStyle: "italic",
  textTransform: "uppercase",
};
const STYLE_TEAM = {
  fontSize: 112,
  textTransform: "uppercase",
};
const STYLE_VS = Object.assign(
  {
    fontSize: 64,
  },
  GRAY_TEXT,
);
const STYLE_SCORE = {
  fontSize: 144,
  fontFamily: "league-gothic-condensed, sans-serif",
};
const STYLE_CONT_LABEL = {
  fontSize: 48,
};
const STYLE_CONT_WINNER = {
  fontFamily: '"acumin-pro-extra-condensed",sans-serif',
  fontSize: 32,
  fontWeight: 300,
  textTransform: "capitalize",
};

function pendingValues(pending) {
  if (!pending || pending.length < 2) {
    return null;
  }
  return [pending[0], pending[1]];
}

function winnerShort(picks, scoreAway, scoreHome) {
  const winner = picks.winnerAt(scoreAway, scoreHome);
  return winner ? winner.shortName : "";
}

class GameLayout extends Component {
  render() {
    const { away, home, picks, scoreAway, scoreHome, awayPending, homePending } = this.props;
    const curWinner = picks.winnerAt(scoreAway, scoreHome);
    const awayPendingVals = pendingValues(awayPending);
    const homePendingVals = pendingValues(homePending);

    const styleAwayColor = { color: away.primaryColor };
    const styleHomeColor = { color: home.primaryColor };

    let vsWinnerColor = null;
    if (scoreAway > scoreHome) {
      vsWinnerColor = away.primaryColor;
    } else if (scoreHome > scoreAway) {
      vsWinnerColor = home.primaryColor;
    }

    return (
      <div style={Object.assign({ width: 800, margin: "30px auto 0", lineHeight: 1 }, FONT_LEAGUE)}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={Object.assign({ color: away.secondaryColor }, STYLE_CITY)}>{away.city}</div>
          <div
            style={Object.assign({ textAlign: "right", color: home.secondaryColor }, STYLE_CITY)}
          >
            {home.city}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
          }}
        >
          <div style={Object.assign({}, STYLE_TEAM, styleAwayColor)}>{away.name}</div>
          <div style={STYLE_VS}>VS</div>
          <div style={Object.assign({ textAlign: "right" }, STYLE_TEAM, styleHomeColor)}>
            {home.name}
          </div>
        </div>
        <div
          style={Object.assign(
            { textAlign: "center", fontSize: 52, margin: "30px 0" },
            FONT_THIN,
            GRAY_TEXT,
            { fontWeight: 200 },
          )}
        >
          Current Winner: <span style={{ color: vsWinnerColor }}>{curWinner.longName}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            lineHeight: 1,
          }}
        >
          <div style={{ color: away.secondaryColor, width: SIDE_WIDTH }}>
            <div style={Object.assign({}, styleAwayColor, STYLE_SCORE)}>{scoreAway}</div>
            {awayPendingVals && (
              <React.Fragment>
                <div style={STYLE_CONT_LABEL}>+{awayPendingVals[0]}</div>
                <div style={STYLE_CONT_WINNER}>
                  {winnerShort(picks, scoreAway + awayPendingVals[0], scoreHome)}
                </div>
                <div style={STYLE_CONT_LABEL}>+{awayPendingVals[1]}</div>
                <div style={STYLE_CONT_WINNER}>
                  {winnerShort(picks, scoreAway + awayPendingVals[1], scoreHome)}
                </div>
              </React.Fragment>
            )}
          </div>
          <div>
            <SquaresTable
              picks={picks}
              away={away}
              home={home}
              scoreAway={scoreAway}
              scoreHome={scoreHome}
              awayPending={awayPending}
              homePending={homePending}
            />
          </div>
          <div
            style={{
              color: home.secondaryColor,
              width: SIDE_WIDTH,
              textAlign: "right",
            }}
          >
            <div style={Object.assign({}, styleHomeColor, STYLE_SCORE)}>{scoreHome}</div>
            {homePendingVals && (
              <React.Fragment>
                <div style={STYLE_CONT_LABEL}>+{homePendingVals[0]}</div>
                <div style={STYLE_CONT_WINNER}>
                  {winnerShort(picks, scoreAway, scoreHome + homePendingVals[0])}
                </div>
                <div style={STYLE_CONT_LABEL}>+{homePendingVals[1]}</div>
                <div style={STYLE_CONT_WINNER}>
                  {winnerShort(picks, scoreAway, scoreHome + homePendingVals[1])}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        <QuarterSummary
          picks={picks}
          away={away}
          home={home}
          awayPeriods={this.props.awayPeriods}
          homePeriods={this.props.homePeriods}
        />
      </div>
    );
  }
}
GameLayout.propTypes = {
  picks: PropTypes.instanceOf(Picks).isRequired,
  scoreAway: PropTypes.number.isRequired,
  scoreHome: PropTypes.number.isRequired,
  awayPeriods: PropTypes.array,
  homePeriods: PropTypes.array,
  awayPending: PropTypes.array,
  homePending: PropTypes.array,

  away: TeamShape.isRequired,
  home: TeamShape.isRequired,
};

export default GameLayout;



// WEBPACK FOOTER //
// ./src/GameLayout.js